module.exports = __webpack_public_path__ + "static/media/Eid_Eladha_ar.c3d69899.jpg";